const AppConstants = {
  api: "https://lionfish-app-wslgy.ondigitalocean.app",
  // api: "http://localhost:5000",
  // api: 'https://api.digimach.io',
};

export default AppConstants